/**
 * HomeENHomeComposeDemoView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeENHomeComposeDemo
 */

import { useHomeENHomeComposeDemoLogic } from '@/hooks/traits/useHomeENHomeComposeDemoLogic';
import type { HomeENHomeComposeDemoConfig } from '@/hooks/traits/useHomeENHomeComposeDemoLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeENDemoComposeTask } from '@app/shared';
import { HomeENDemoComposeTourView } from '@/components/traits/HomeENDemoComposeTourView';
import { Split } from '@almadar/ui/components';
import { HomeENDemoComposeEquationView } from '@/components/traits/HomeENDemoComposeEquationView';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface HomeENHomeComposeDemoViewProps {
  config?: Partial<HomeENHomeComposeDemoConfig>;
}

export function HomeENHomeComposeDemoView({ config: propsConfig }: HomeENHomeComposeDemoViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeENHomeComposeDemoLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeENDemoComposeTask'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeEN" trait="HomeENHomeComposeDemo">
      {slotWriter['main'] === 'INIT' ? (<Split gap="xl" ratio="1:3" align="start"><HomeENDemoComposeEquationView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeENDemoComposeTourView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Split>) : null}
    </TraitScopeProvider>
  );
}

export default HomeENHomeComposeDemoView;
